export const environment = {
  production: true,
  api: 'https://bazait.com/api',
  baseTitle: 'BazaIT',
  baseURL: 'https://bazait.com',
  urlPlatform: 'https://app.bazait.com/',
  amplitudeApiKey: '3765fe30264d8b0c72d1be7000bbc308',
  translateProject: '1'
};
